var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69 13.1462C6.402 12.9725 6.098 12.7882 5.8 12.5702C5.64849 12.4612 5.44579 12.4436 5.27639 12.5249C5.107 12.6062 5 12.7724 5 12.9542V22.5542C4.99964 22.7487 5.12146 22.9241 5.30854 22.9985C5.49561 23.073 5.71099 23.0317 5.854 22.8941C6.282 22.4832 6.675 22.1645 7.014 21.889C7.845 21.216 8.5 20.6851 8.5 19.68V15.36C8.5 14.2406 7.58 13.6838 6.69 13.1462Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.182 12.5693C22.0743 12.5404 21.9999 12.4462 22 12.3389V9.6C22 4.29807 17.5228 0 12 0C6.47715 0 2 4.29807 2 9.6V12.3408C2.00043 12.4482 1.92586 12.5426 1.818 12.5712C0.742418 12.864 7.9117e-05 13.8067 0 14.88V20.64C0 21.2765 0.263392 21.887 0.732233 22.3371C1.20107 22.7871 1.83696 23.04 2.5 23.04H3.5C3.77614 23.04 4 22.8251 4 22.56V9.6C4 5.35845 7.58172 1.92 12 1.92C16.4183 1.92 20 5.35845 20 9.6V22.56C20 22.8251 20.2239 23.04 20.5 23.04H21.5C22.163 23.04 22.7989 22.7871 23.2678 22.3371C23.7366 21.887 24 21.2765 24 20.64V14.88C24.0008 13.806 23.2583 12.8623 22.182 12.5693Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 12.576C17.9 12.7901 17.6 12.9744 17.31 13.152C16.42 13.6896 15.5 14.2464 15.5 15.36V19.68C15.5 20.687 16.155 21.216 16.986 21.8947C17.325 22.1702 17.718 22.4889 18.146 22.8998C18.289 23.0375 18.5044 23.0787 18.6915 23.0043C18.8785 22.9298 19.0004 22.7544 19 22.56V12.96C19 12.7782 18.893 12.612 18.7236 12.5307C18.5542 12.4494 18.3515 12.4669 18.2 12.576Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.75b2f161.svg";
export { ForwardRef as ReactComponent };